






























import { defineComponent, PropType, ref } from "@vue/composition-api";
import {
  LiveChatInvitation,
  LiveChatInvitationStatus,
} from "@scrile/api-provider/dist/api/LiveChatInvitationsProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { liveNames } from "@/lib/liveHelpers";
import { getCollabLiveUrl } from "@/lib/urlHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseConfirmWithAvatar from "@/components/BaseConfirmWithAvatar";

export default defineComponent({
  name: "ConfirmLiveChatInvitation",
  components: { BaseButton, BaseConfirmWithAvatar, BaseConfirm },
  props: {
    invitation: { type: Object as PropType<LiveChatInvitation>, required: true },
    cb: { type: Function as PropType<(data: LiveChatInvitation) => void> },
  },
  setup(props, { root, emit }) {
    const processingApprove = ref(false);
    const processingDecline = ref(false);
    const users = [props.invitation.sender, props.invitation.recipient];
    const title = $t("{0} invites you to {1}", [
      props.invitation.sender?.screenName ?? "",
      liveNames[props.invitation.subject.subjectType],
    ]);

    const onApprove = async () => {
      try {
        processingApprove.value = true;
        const res = await providers.LiveChatInvitationsProvider.update({
          data: {
            id: props.invitation.id,
            status: LiveChatInvitationStatus.ACCEPTED,
          },
        });
        props.cb && props.cb(res);
        props.invitation.recipient &&
          root.$router.push(getCollabLiveUrl(props.invitation.recipient, props.invitation.subject.subjectId));
      } finally {
        processingApprove.value = false;
        emit("done");
      }
    };

    const onDecline = async () => {
      try {
        processingDecline.value = true;
        const res = await providers.LiveChatInvitationsProvider.update({
          data: {
            id: props.invitation.id,
            status: LiveChatInvitationStatus.CANCELLED,
          },
        });
        props.cb && props.cb(res);
      } finally {
        processingDecline.value = false;
        emit("done");
      }
    };

    return {
      title,
      users,
      processingApprove,
      processingDecline,
      onApprove,
      onDecline,
    };
  },
});
